/**
 * 1.72 — a comma going into a number field is the decimal point.
 *
 * A Georgian keyboard types „12,5", and a document pasted from says „9,75". Chrome's
 * `type="number"` takes only its own UI language's separator, and in an English or
 * a Georgian Chrome it silently DROPPED the comma: „12,5" became 125, a cost of
 * „9,75" became 975 (measured in the walk of a chicken shop's first day, 2026-11-04;
 * a Russian Chrome kept it). A weight ten times too much, with nothing on the screen
 * to say why.
 *
 * One listener for every number field in the app, so no field can forget, and it
 * runs before the field's own handling. The text fields that read a comma themselves
 * (the weight window, the cart's quantity) never come here.
 *
 * A comma is always the decimal here, as it is in Georgian: „1,200" typed by hand is
 * 1.2 (it used to be 1200), and the field shows „1.200". What already says what its
 * comma is — „1,234.50", „1,234,567" — stays the browser's.
 */
export function decimalText(target: EventTarget | null, data: string | null | undefined): string | null {
  const el = target as { tagName?: string; type?: string } | null
  if (!data || el?.tagName !== 'INPUT' || el.type !== 'number') return null
  const s = data.trim()
  return /^\d*,\d*$/.test(s) ? s.replace(',', '.') : null
}

export function installDecimalComma(doc: Document = document): void {
  doc.addEventListener('beforeinput', (e) => {
    const text = decimalText(e.target, (e as InputEvent).data)
    if (text === null) return
    // The one way to put text into a number field at its caret: it has no selection API, and
    // this goes through the field's own input event, so React sees it as typing. Refused, the
    // key stays the browser's: nothing is swallowed.
    if (doc.execCommand('insertText', false, text)) e.preventDefault()
  }, true)
}
